import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import Select from 'components/Selectors/Select/mobile';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/view/desktop';

import PercentInfo from '../../../PlayerReports/PlayerDeposits/Table/PercentInfo';

import './Table.scss';

const b = block('request-history-table-desktop');

const Table = ({ model }) => {
  const locale = useSelector(s => s.locale.locale);

  const { state, handlers, output } = model;

  const items = output.items.map(item => (
    <div className={b('row')} key={item.id}>
      <div className={b('row-item', { type: 'date' })}>
        <span className={b('row-item2')}>
          {dayjs(item.createdAt, 'DD/MM/YY HH:mm', true).format('HH:mm     DD.MM.YYYY')}
        </span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{item.id}</span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{item.username}</span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{locale.paymentStatuses[item.type] ?? ''}</span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{Object.keys(item?.bank).length === 0 ? '' : item.bank.bank}</span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{Object.keys(item?.bank).length === 0 ? '' : item.bank.details}</span>
      </div>
      <div className={b('row-item', { withIcon: !!item.promoCodePercent })}>
        <span className={b('row-item2')}>{item.amount}</span>
        <PercentInfo percent={item.promoCodePercent} />
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{item.bankHolder}</span>
      </div>
      <div className={b('row-item')}>
        <span className={b('row-item2')}>{locale.statusesForPayment[item.status]}</span>
      </div>
    </div>
  ));

  const headers = [
    locale.date,
    locale.id,
    locale.username,
    locale.operation,
    locale.bank,
    locale.details,
    locale.amount,
    locale.nameUsers,
    locale.status,
  ].map((v, index) =>
    Array.isArray(v) ? (
      <div className={b('row-item')} key={index}>
        {v.map((item, subIndex) => (
          <span className={b('row-sub-item')} key={subIndex}>
            {item}
          </span>
        ))}
      </div>
    ) : (
      <div className={b('row-item')} key={index}>
        {v}
      </div>
    ),
  );

  return (
    <div className={b()}>
      <div className={b('header')}>
        <h2 className={b('header-title')}>{locale.result}</h2>
        <h2 className={b('header-text')}>{locale.elementsOnPage}</h2>
        <div className={b('header-select')}>
          <Select
            items={state.values.itemsOnPage}
            onChange={v => handlers.handleValueChange('itemsOnPage', v)}
            color="grey"
          />
        </div>
      </div>
      <div className={b('content')}>
        <div className={b('row', { type: 'header' })}>{headers}</div>
        {items.length ? items : <div className={b('no-results')}>{locale.noResults}</div>}
        <div className={b('pagination')}>
          <div>{`${output.count} ${locale.records}`}</div>
          <PaginatorSwitcher
            onPageClick={v => handlers.handleValueChange('page', v)}
            count={output.count}
            currentPage={state.values.page}
            itemsOnPage={output.activeItemsOnPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Table;
